import { render } from "./footprint.vue?vue&type=template&id=9f0aafca&ts=true"
import script from "./footprint.vue?vue&type=script&lang=ts"
export * from "./footprint.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__